export const actionTypes = {
  DELETE: 'delete',
  ASSIGN: 'assign',
  ARCHIVE: 'archive',
};
